import { FC, PropsWithChildren } from "react";

interface TabPanelProps extends PropsWithChildren {
  index: any;
  value: any;
}

export const TabPanel: FC<TabPanelProps> = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ marginBottom: "145px" }}
      {...other}
    >
      {value === index && children}
    </div>
  );
};
